export default "__VITE_ASSET__aa34d369__"